export const color = {
  main: "#f39c12",
  black: "#000000",
  grey: "#EEEEEE",
  white: "#FFFFFF",
};
